/* globals google */

export default class GoogleMap {
  constructor () {
    this.mapLayer = null
    this.infoWinodw = null
    this.markerZoomOffset = 0
    this.markers = []

    // eslint-disable-next-line
    const initMap = new Promise(() => {
      if (window.innerWidth >= 576) this.markerZoomOffset = 0.004
      const UK = { lat: 51.507, lng: 0.127 }
      const UK_BOUNDS = {
        north: 62,
        south: 49.5,
        east: 5,
        west: -14
      }
      const mapSettings = {
        center: UK,
        zoomControl: false,
        restriction: {
          latLngBounds: UK_BOUNDS,
          strictBounds: false
        },
        mapTypeControlOptions: {
          mapTypeIds: ['roadmap']
        },
        mapTypeId: 'roadmap',
        disableDefaultUI: true,
        zoom: 6
      }
      this.mapLayer = new google.maps.Map(document.getElementById('map'), mapSettings)
      this.infoWindow = new google.maps.InfoWindow()
    })
    return this
  }

  removeStorePins () {
    if (this.markers && !this.markers.length) return false
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null)
    }
    this.markers = []
  }

  addStorePin (store, order = null, onclick = null, activeStore = null, isClickAndCollect = false) {
    const isActiveStore = store.id === activeStore
    const orderText = isClickAndCollect ? ' ' : order !== null ? parseInt(order + 1) : ' '
    const label = {
      text: `${orderText}`,
      color: 'white',
      fontFamily: 'ArgosCondensed',
      fontSize: isActiveStore ? '18px' : '12px',
      fontWeight: '400'
    }

    const storeType = store.type === 0 ? 'red' : store.type === 1 ? 'orange' : 'black'
    const icon = {
      url: `//documents.4rgos.it/v1/static/icon-pin-${storeType}`,
      scaledSize: isActiveStore ? new google.maps.Size(45, 45) : new google.maps.Size(30, 30),
      labelOrigin: isActiveStore ? new google.maps.Point(22, 16) : new google.maps.Point(15, 12)
    }

    const marker = new google.maps.Marker({
      position: { lat: store.lat, lng: store.lng },
      map: this.mapLayer,
      label,
      icon
    })
    this.markers.push(marker)

    google.maps.event.addListener(marker, 'click', () => {
      if (onclick !== null) onclick(null, store, order)
      this.mapLayer.setZoom(16)
      const offsetPos = {
        lng: marker.getPosition().lng() - this.markerZoomOffset,
        lat: marker.getPosition().lat()
      }
      this.mapLayer.setCenter(offsetPos)
    })
  }

  removeGeoPins () {
    this.infoWindow.close()
    this.infoWindow = null
  }

  goToLocation (lat, lng, zoom = 16, offset = false) {
    this.mapLayer.setZoom(zoom)
    this.mapLayer.setCenter({ lat, lng: lng - (!offset ? 0 : this.markerZoomOffset) })
  }

  geoLocate (geolocateResponseFn) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          this.infoWindow.setPosition(pos)
          const content = '<div id="google-popup"></div>'
          this.infoWindow.setContent(content)
          this.infoWindow.open(this.mapLayer)
          // this.mapLayer.setCenter(pos)
          geolocateResponseFn(pos, 'success')
        },
        () => geolocateResponseFn(null, 'error')
      )
    } else {
      // Browser doesn't support Geolocation
      geolocateResponseFn(null, 'error')
    }
  }

  zoomToBounds () {
    const bounds = new google.maps.LatLngBounds()
    for (let i = 0; i < this.markers.length; i++) {
      bounds.extend({
        lat: this.markers[i].getPosition().lat(),
        lng: this.markers[i].getPosition().lng() - this.markerZoomOffset
      })
    }
    this.mapLayer.fitBounds(bounds)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/map.js